import type { IconData } from '@stacksjs/iconify-core'

export const arrowCircleRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m12.707 16.707l4-4a1.004 1.004 0 0 0 0-1.414l-4-4a1 1 0 0 0-1.414 1.414L13.586 11H8a1 1 0 0 0 0 2h5.586l-2.293 2.293a1 1 0 0 0 1.414 1.414\"/><path fill=\"currentColor\" d=\"M22 12a10 10 0 1 0-10 10a10.01 10.01 0 0 0 10-10m-10.707 4.707a1 1 0 0 1 0-1.414L13.586 13H8a1 1 0 0 1 0-2h5.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4a1.004 1.004 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowCircleRight
